
// 连接地址
var ymtApi = "http://47.102.206.77:7104/api/";

var encryStr="e27cf544-5d87-4e59-b507-553b8c3068d1"
var lochost=window.location.host

if(lochost.indexOf('yunmaotong')>-1){
  if(window.location.href.startsWith("https")){
    ymtApi = "https://cloud.khd.api.yunmaotong.net/api/"
  } else {
    ymtApi = "http://cloud.khd.api.yunmaotong.net/api/"
  }
  encryStr="e15d67a0-887b-99e4-ca3c-6a4c9a81fc0e";
}
else{
  ymtApi = "http://47.102.206.77:7104/api/"
  encryStr;
}

export default {
  ymtApi,
  encryStr
};



// WEBPACK FOOTER //
// ./src/utils/global.js